// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__D0M5u","question":"Question_question__23TST","description":"Question_description__d2vj4"};